import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies, topicCollections } from "@/mocks/movies";

export default function TopicCollections() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="mb-8">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          <Link to="/category">推荐专题</Link>
        </h2>
        <p className="mt-2 text-sm text-foreground-600">围绕不同观影场景精心策划的片单合集</p>
      </div>

      <div className="space-y-10">
        {topicCollections.map((topic) => {
          const list = topic.movieIds
            .map((id) => movies.find((m) => m.id === id))
            .filter((m): m is (typeof movies)[number] => Boolean(m));

          return (
            <div key={topic.id}>
              <div className="mb-4 flex flex-wrap items-end justify-between gap-3 border-l-4 border-accent-500 pl-4">
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{topic.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500 md:text-sm">{topic.subtitle}</p>
                </div>
                <Link
                  to="/category"
                  className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  更多
                  <i className="ri-arrow-right-line leading-none"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
                {list.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}